import { useQuery } from 'react-query';
import { queryKey } from 'constants/queryKey';
import TranslationApi, {
  TranslationLanguageOption,
} from 'app/modules/posts/modules/translation/api/translationApi';

const STALE_TIME = 1000 * 60 * 60;

export function useTranslationLanguages() {
  return useQuery<TranslationLanguageOption[]>(
    queryKey.translationLanguages(),
    TranslationApi.getLanguages,
    {
      staleTime: STALE_TIME,
    },
  );
}
